// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';
import { COMPUTER_SMALL_WIDTH, TABLET_WIDTH, CELLPHONE_WIDTH } from '../../helpers/constants';

const NavBarWrapper: StatelessFunctionalComponent<*> = styled.div`
  background-color: var(--white-color);
  /* overflow: hidden !important; */
  position: relative !important;
  .active-page {
    color: var(--text-color-2) !important;
    text-decoration: underline !important;
  }

  .navbar {

    &__container {
      border-bottom: 2px solid var(--blue-color);
      min-height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 50px;
      font-family: var(--font-family-alt);
    }

    &__links {
      font-size: 2.4em;
      font-weight: 500;

      a {
        color: var(--blue-color);
        text-decoration: none;
        font-weight: bold;
      }
    }

    &__links  * {
      margin-right: 30px;
    }

    &__right-section {
      display: flex;
      align-items: center;
      font-size: 2em;

      a {
        display: flex;
        align-items: center;
        color: var(--blue-color);
        text-decoration: none;
      }

      .iconUser {
        width: 14.5px;
        height: 24px;
        margin-right: 10px;
      }

      .iconNoti {
        width: 24px;
        height: 24px;
      }

      .alert {
        background-color: orange;
        color: var(--white-color);
        border-radius: 12px;
        width: 18px;
        height: 18px;
        font-size: 0.5em;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 10px;
        margin-left: 15px;
      }

    }

    &__right-section > * {
      margin: 0 8px;
    }

    &__button * {
      background-color: var(--white-color);
      display: flex;
      margin-right: 10px;
    }

    &__button--reset {
      cursor: pointer;
      border: 0;
      background: transparent;
      font: inherit;
      margin: 0;
      padding: 0;

      > img {
        margin-right: 0;
      }
    }

    &__notiWrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
    }

  }

  @media only screen and (max-width: ${COMPUTER_SMALL_WIDTH}px) {
    .navbar {
      &__container {
        padding: 0 25px;
      }

      &__links {
        font-size: 1.8em;
      }

      &__links * {
        margin-right: 15px;
      }

      &__right-section {
        font-size: 1.6em;
      }

      &__right-section > * {
        margin: 0 4px;
      }
    }
  }

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
    .navbar {
      &__container {
        padding: 0 15px;
        min-height: 60px;
      }

      &__links {
        font-size: 1.8em;
      }

      &__links * {
        margin-right: 5px;
      }

      &__right-section {
        font-size: 1.6em;
      }

      &__grid {
        display: grid;
      }
    }
  }

  @media only screen and (max-width: ${CELLPHONE_WIDTH}px) {
    .navbar {
      &__container {
        padding: 25px 15px 25px 15px;
        flex-direction: column-reverse;
      }

      &__links {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &__links * {
        margin-top: 15px;
      }

      &__right-section {

      }

      &__right-section > * {
        margin: 0 6px;
      }

      &__grid {
        display: grid;
      }
    }
  }

  .dropdown {
    &-content {
      display: none;
      position: absolute;
      min-width: 160px;
      overflow: auto;
      background: white;
      border-radius: 10px;
      margin: 5px 0;
      box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);

      > a {
        padding: 12px 16px;
      }
    }

    &-button {
      display: flex;
      align-items: center;
      color: var(--blue-color);
      text-decoration: none;
      border: none;
      cursor: pointer;
    }

    &-show { display: block; }
  }
`;

export default NavBarWrapper;
